import { Component, Input } from '@angular/core';
import {
  resolveStatusBadgeType,
  StatusBadgeType,
} from '../status-badge/status-badge-code';

export type OutlineBadgeType = StatusBadgeType;

@Component({
  selector: 'app-outline-badge',
  templateUrl: './outline-badge.component.html',
  styleUrls: ['./outline-badge.component.scss'],
  standalone: false,
})
export class OutlineBadgeComponent {
  @Input() type: OutlineBadgeType | number = 'default';
  @Input() label = '';
  @Input() dot?: boolean = false;
  @Input() rounded?: boolean = false;

  get resolvedType(): OutlineBadgeType {
    return resolveStatusBadgeType(this.type);
  }
}
